import { render, staticRenderFns } from "./ProposalDetailOffers.vue?vue&type=template&id=64f71b87"
import script from "./ProposalDetailOffers.vue?vue&type=script&lang=js"
export * from "./ProposalDetailOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports